// extracted by mini-css-extract-plugin
module.exports = {"pagination":"index_pagination__3fY4b","page":"index_page__pR_Ac","input":"index_input__2TdjE","btn":"index_btn__2Cfad"};